  
        $('.u_slider_for').slick({
         slidesToShow: 1,
         slidesToScroll: 1,
         arrows: true,
         fade:true,
         infinite:false,
         asNavFor:'.u_slider_nav',
          arrows:'false',
        adaptiveHeight: true,
          swipe:false,
            responsive: [
    {
      breakpoint: 990,
      settings: {
       swipe:true,
        dots:false,
      }
    }
              ]
});
$('.u_slider_nav').slick({
  slidesToShow: 5,
  slidesToScroll: 1,
  asNavFor:'.u_slider_for',
  infinite:false,
  focusOnSelect: true,
  arrows:'false',
});
$('.u_minus').click(function(){
    var input =$(this).parent().find('.u_number');
     console.log('input',input);
    var count =parseInt(input.val()) -1;
    console.log(count);
    count = count <1 ? 1:count;
  console.log('count',count);
    input.val(count);
    input.attr('value',count)
  })
  $('.u_plus').click(function(){
    var input =$(this).parent().find('.u_number');
    console.log('input',input);
       let val =parseInt(input.val());   
  let var_policy =  $('.u_pro_var_plicy').val()
      let var_manag =  $('.u_pro_var_manag').val()
     let var_qty =  parseInt($('.u_pro_qty_total').val())
     if(var_policy == 'deny' && var_manag == 'shopify'){
      if(var_qty !=  val){
         let count =parseInt(input.val()) +1;
          console.log('count',count);
    input.val(count);
    input.attr('value',count)
      }
       else{
         console.log('maximum limit of this variant has been reached')
       }
     }
       else{
        let count =parseInt(input.val()) +1;
          console.log('count',count);
    input.val(count);
    input.attr('value',count)
       }
  })
  
    $(document).ready(function(){
    pro_swatches();
  })
  $('.u_radio_btn').change(function(){
    pro_swatches()
  })
  function pro_swatches(){
    let final ='';
    let comb= '';
    $('.u_radio_btn:checked').each(function(){
      let checked_val= $(this).val(); 
      comb += checked_val + ' / '
    })
    console.log(comb)
    var finall =comb.slice(0 ,comb.length-2).trim();
    console.log('--final combination',finall);

    let flag=false;
    $(".u_master_select option").each(function(){
      var word =$(this).attr('data-title').trim();
      if(word == finall){
        console.log('---',word);
        flag =true; 
      } 

    }); 
    if(flag==true)
    {
      //master select
      $(".u_master_select option").each(function(){
        if($(this).attr('data-title').trim() == finall){
          $('.u_master_select').val($(this).val()).trigger('change');
           let variant_id =  $(this).attr('value');
           history.pushState({}, '','?variant='+variant_id);
          $('.product-variant-id').val(variant_id);
          // variant change price
          var variant_price = $(this).attr('price-data');
          console.log('variant price',variant_price);

          let variant_image =  $(this).attr('data-image');
            console.log("Variant Image -------", variant_image);
            $(".u_slider_nav .slick-slide").each(function(){
let thumb_image =  $(this).attr('data-image');
              if(variant_image == thumb_image){
              console.log("Thumb Image -------", thumb_image);
                $(this).trigger('click');
            }
              });
          
          $('.u_pro_price').text(Shopify.formatMoney(variant_price));
          if(typeof $(this).attr('compare-price-data') != 'undefined'){
          let compare_variant_price = $(this).attr('compare-price-data');
          $('.u_pro_cprice').text(Shopify.formatMoney(compare_variant_price));
          }
          else{
                      $('.u_pro_cprice').empty();
          }
         
           $('.u_number').attr('value',1);
          $('.u_number').val(1);
           let var_policy = $(this).attr('var-policy')
      let var_manag = $(this).attr('var-manag')
          let var_qty = parseInt($(this).attr('data-iq'));
          $('.u_pro_qty_total').val(var_qty);
          $('.u_pro_var_plicy').val(var_policy)
          $('.u_pro_var_manag').val(var_manag)
           if(var_policy == 'deny' && var_manag == 'shopify'){
      if(var_qty > 0){
              $('.product-form__submit span').text('Add to cart');
      $('.product-form__submit').prop("disabled", false)
        
      }
      else{
              $('.product-form__submit span').text('sold out')
            $('.product-form__submit').prop("disabled", true)
      }
    }
    else{
              $('.product-form__submit span').text('Add to cart');
      $('.product-form__submit').prop("disabled", false)
    }
        }
        });
        }          
    else{
      console.log(' combination does not exists');   
    }
  }
  $('.u_accordian_head').click(function(){               
                if($(this).next().hasClass('active'))
                {
                    $(this).next().removeClass('active').slideUp();
                    $(this).find('.u_icon i').addClass('fa-plus').removeClass('fa-minus');
                }
                else{
                    $('.u_accordian_body').removeClass('active').slideUp();
                $('.u_icon i').addClass('fa-plus').removeClass('fa-minus');
            $(this).next('.u_accordian_body').addClass('active').slideDown();
            $(this).find('.u_icon i').addClass('fa-minus').removeClass('fa-plus');
                }
            })
